import { forwardRef } from 'react';
import { LinkProps } from 'react-router-dom';

import { TableRow, TableRowProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { useNavigate } from '../../behaviors';

const isExternalUrl = (to: LinkProps['to']): boolean =>
  typeof to === 'string' && /^([a-z+.-]+):/.test(to);

const useStyles = makeStyles(() => ({
  row: {
    cursor: 'pointer',
  },
}));

export type LinkableTableRowProps = TableRowProps & {
  to: LinkProps['to'];
};

export const LinkableTableRow = forwardRef<
  HTMLTableRowElement,
  LinkableTableRowProps
>(({ children, to, hover = true, className, ...tableRowProps }, ref) => {
  const navigate = useNavigate();
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    if (!to) return;

    const target = event.target as Element | null;
    const clickedInAnchor = Boolean(target && target.closest('a'));
    if (clickedInAnchor) return;

    const url = typeof to === 'string' ? to : to.pathname || '';
    const external = isExternalUrl(to);

    if (event.metaKey || event.ctrlKey || external) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    navigate(to);
  };

  return (
    <TableRow
      ref={ref}
      hover={hover}
      className={classNames(classes.row, className)}
      onClick={handleClick}
      {...tableRowProps}
    >
      {children}
    </TableRow>
  );
});
LinkableTableRow.displayName = 'LinkableTableRow';
